import React, { useRef } from 'react';
interface VoiceScrubberProps {
  bars: number[];
  progress: number;
  duration: number;
  elapsed: number;
  setProgress: (updater: number | ((p: number) => number)) => void;
  draggingRef: React.MutableRefObject<boolean>;
  fillClass: string;
  trackClass: string;
  thumbClass: string;
}

/** WhatsApp-style waveform you can tap or drag to seek. */
export function VoiceScrubber({
  bars,
  progress,
  duration,
  elapsed,
  setProgress,
  draggingRef,
  fillClass,
  trackClass,
  thumbClass
}: VoiceScrubberProps) {
  const ref = useRef<HTMLDivElement>(null);
  const seek = (clientX: number) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    setProgress(Math.min(1, Math.max(0, (clientX - rect.left) / rect.width)));
  };
  return <div ref={ref} role="slider" tabIndex={0} aria-label="Seek recording" aria-valuemin={0} aria-valuemax={duration} aria-valuenow={elapsed} onKeyDown={e => {
    if (e.key === 'ArrowRight') setProgress(p => Math.min(1, p + 1 / duration));
    if (e.key === 'ArrowLeft') setProgress(p => Math.max(0, p - 1 / duration));
  }} onPointerDown={e => {
    e.stopPropagation();
    draggingRef.current = true;
    e.currentTarget.setPointerCapture(e.pointerId);
    seek(e.clientX);
  }} onPointerMove={e => {
    if (draggingRef.current) seek(e.clientX);
  }} onPointerUp={e => {
    draggingRef.current = false;
    e.currentTarget.releasePointerCapture(e.pointerId);
  }} className="relative flex h-5 min-w-[96px] flex-1 cursor-pointer touch-none items-center gap-[2px] focus-visible:outline-none" data-id="element-466" data-mp="30fpcp7mkdpb5">
      {bars.map((h, i) => <span key={i} style={{
      height: `${h}%`
    }} className={`w-[2px] flex-1 rounded-full transition-colors duration-100 ${(i + 0.5) / bars.length <= progress ? fillClass : trackClass}`} data-id="element-467" data-mp="2kcep4jgr2c38" data-mpi={i} />)}
      <span style={{
      left: `${progress * 100}%`
    }} className={`pointer-events-none absolute top-1/2 h-2.5 w-2.5 -translate-x-1/2 -translate-y-1/2 rounded-full shadow-sm ${thumbClass}`} data-id="element-468" data-mp="15spdul73kde" />
    </div>;
}